import { create } from "zustand";

// UI-only state lives here. Server state lives in TanStack Query.
interface UIState {
  selectedId: string | null;
  select: (id: string | null) => void;
  hideRejected: boolean;
  toggleHideRejected: () => void;
}

export const useUI = create<UIState>((set) => ({
  selectedId: null,
  select: (id) => set({ selectedId: id }),
  hideRejected: true,
  toggleHideRejected: () =>
    set((s) => ({ hideRejected: !s.hideRejected })),
}));
